/*
 * @Date: 2021-10-19 17:33:29
 * @LastEditors: OBKoro1
 * @LastEditTime: 2022-09-28 16:56:45
 * @FilePath: \geoppt-admin-web\src\app\layout\layout-basic\layout-basic.module.ts
 */
import { NgModule } from '@angular/core';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { IconsProviderModule } from 'src/app/icons-provider.module';
import { AppFrameLayoutComponent } from './app-frame-layout.component';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { UserService } from 'src/app/pages/user/user.service';
import { BrowserModule } from '@angular/platform-browser';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { AppMenuComponent } from './app-menu.component';
import { NzModalModule } from 'ng-zorro-antd/modal';

@NgModule({
  declarations: [
    AppFrameLayoutComponent,
    AppMenuComponent,
  ],
  imports: [
    NzDropDownModule,
    NzAvatarModule,
    AppRoutingModule,
    IconsProviderModule,
    NzLayoutModule,
    NzMenuModule,
    NzTabsModule,
    BrowserModule,
    NzModalModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports:[
    AppFrameLayoutComponent,  //模块中导出组件
    AppMenuComponent
  ],
  providers: [UserService],
  // bootstrap: [LayoutBasicComponent]
})
export class LayoutBasicModule { }
